import { Box, IconButton, Typography } from "@mui/material";
import {
  PencilSimpleIcon,
  CheckIcon,
  TrashSimpleIcon,
} from "@phosphor-icons/react";
import { InvoiceItemDto } from "../../../models/dto/CreateInvoiceDto";
import { useEffect, useState } from "react";
import { AddInvoiceItem } from "./addInvoiceItem";

type CreateInvoiceItemRowProps = {
  index: number;
  invoiceItem: InvoiceItemDto;
  onRemove: (invoiceItem: InvoiceItemDto) => void;
  onChange: (id: string, value: string | number) => void;
  onEditItem: (id: string, value: string | number, index: number) => void;
};

const unitLabels: Record<string, string> = {
  C62: 'Stuks',
  HUR: 'Uur',
};


export const CreateInvoiceItemRow = ({
  index,
  invoiceItem,
  onRemove,
  onChange,
  onEditItem
}: CreateInvoiceItemRowProps) => {
  const [removeConfirmation, setremoveConfirmation] = useState<boolean>(false);
  const [editConfirmation, setEditConfirmation] = useState<boolean>(false);

  const handleRemove = () => {
    onRemove(invoiceItem);
    setremoveConfirmation(false);
  };

  const handleEdit = (id: string, value: string | number) => {
    onEditItem(id, value, invoiceItem.position)
  };

  useEffect(() => {
    if (!removeConfirmation) return;
    setTimeout(() => {
      setremoveConfirmation(false);
    }, 5000);
  }, [removeConfirmation]);

  return (
    <Box className="row">
      {editConfirmation ? (
        <IconButton className="edit" onClick={() => setEditConfirmation(false)}>
          <CheckIcon size={24} weight="bold" />
        </IconButton>
      ) : (
        <IconButton onClick={() => setEditConfirmation(true)} className="edit">
          <PencilSimpleIcon size={24} weight="bold" />
        </IconButton>
      )}
      {editConfirmation ? (
        <AddInvoiceItem invoiceItems={[]} newInvoiceItem={invoiceItem} onChange={handleEdit} editMode={editConfirmation}/>
      ) : (
        <>
          <Box className="position tableItem">
            <Typography variant="h4">{invoiceItem.position}</Typography>
          </Box>
          <Box className="description tableItem">
            <Typography variant="h4">{invoiceItem.description}</Typography>
          </Box>
          <Box className="unitPrice tableItem">
            <Typography variant="h4" className="euro">
              &#8364;
            </Typography>
            <Typography variant="h4" className="price">
              {Number(invoiceItem.unitprice).toFixed(2)}
            </Typography>
          </Box>
          <Box className="amount tableItem">
            <Typography variant="h4">{invoiceItem.amount}</Typography>
          </Box>
          <Box className="unit tableItem">
            <Typography variant="h4">{unitLabels[invoiceItem.unit] ?? invoiceItem.unit}</Typography>
          </Box>
          <Box className="totalBefore tableItem">
            <Typography variant="h4" className="euro">
              &#8364;
            </Typography>
            <Typography variant="h4" className="price">
              {invoiceItem.priceBefore.toFixed(2)}
            </Typography>
          </Box>
          <Box className="vat tableItem">
            <Typography variant="h4">{invoiceItem.vat}%</Typography>
          </Box>
          <Box className="total tableItem">
            <Typography variant="h4" className="euro">
              &#8364;
            </Typography>
            <Typography variant="h4" className="price">
              {invoiceItem.priceTotal.toFixed(2)}
            </Typography>
          </Box>
        </>
      )}

      {removeConfirmation ? (
        <IconButton onClick={handleRemove} className="remove">
          <CheckIcon size={24} weight="bold" />
        </IconButton>
      ) : (
        <IconButton
          onClick={() => setremoveConfirmation(true)}
          className="remove">
          <TrashSimpleIcon size={24} weight="bold" />
        </IconButton>
      )}
    </Box>
  );
};
